import type { ShortcutHandlerContext } from '../../../../../lib/types.js';
import { assertBridgeWorkspace } from '../../../../lib/assert-bridge-workspace.js';
import { handleShortcutFileBrowserRead } from '../../../../lib/file-browser/handle-read.js';

/** GET /api/bridges/files/read */
export async function GET(ctx: ShortcutHandlerContext): Promise<void> {
  if (!assertBridgeWorkspace(ctx)) return;
  await handleShortcutFileBrowserRead(ctx);
}
